import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@assets/images/orderlist/orderlistshop.png';
import _imports_1 from '@assets/images/orderlist/ziyinglogo.png';
import _imports_2 from '@assets/images/orderlist/logoicon.png';
const _withScopeId = n => (_pushScopeId("data-v-1adb1b9f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "goodInfo"
};
const _hoisted_2 = {
  key: 0,
  class: "title"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0
}, null, -1));
const _hoisted_4 = {
  key: 0,
  class: "ziyinglogo",
  src: _imports_1
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "next",
  src: _imports_2
}, null, -1));
const _hoisted_6 = {
  key: 1,
  class: "good_card_list"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "good_card-box"
};
const _hoisted_9 = {
  class: "img"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "info"
};
const _hoisted_12 = {
  class: "cont"
};
const _hoisted_13 = {
  key: 0,
  class: "yushou"
};
const _hoisted_14 = {
  class: "time"
};
const _hoisted_15 = {
  key: 0,
  class: "price"
};
const _hoisted_16 = {
  class: "money",
  style: {
    "border": "0"
  }
};
const _hoisted_17 = {
  class: "gray"
};
const _hoisted_18 = {
  key: 1,
  class: "price"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text"
}, "总实付", -1));
const _hoisted_20 = {
  class: "money"
};
const _hoisted_21 = {
  class: "gray"
};
const _hoisted_22 = {
  class: "gray"
};
const _hoisted_23 = {
  key: 0,
  class: "refund_btn"
};
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
  class: "img"
};
const _hoisted_26 = ["src"];
const _hoisted_27 = {
  class: "info"
};
const _hoisted_28 = {
  class: "cont"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tedian"
}, "特典", -1));
const _hoisted_30 = {
  class: "time"
};
const _hoisted_31 = {
  class: "price"
};
const _hoisted_32 = {
  class: "money",
  style: {
    "border": "0"
  }
};
const _hoisted_33 = {
  class: "gray"
};
const _hoisted_34 = {
  key: 2,
  class: "tipshr"
};
const _hoisted_35 = {
  key: 3,
  class: "tips"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont"
}, null, -1));
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" 若有优惠，优惠将在付尾款时使用 ");
const _hoisted_38 = [_hoisted_36, _hoisted_37];
const _hoisted_39 = {
  key: 0,
  class: "steps"
};
const _hoisted_40 = {
  class: "steps-line"
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1));
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1));
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1));
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1));
const _hoisted_45 = [_hoisted_41, _hoisted_42, _hoisted_43, _hoisted_44];
const _hoisted_46 = {
  class: "step_title"
};
const _hoisted_47 = {
  key: 0,
  class: "steps-time"
};
const _hoisted_48 = {
  key: 1,
  class: "right-price"
};
const _hoisted_49 = {
  key: 0,
  class: "steps-price"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "店铺优惠", -1));
const _hoisted_51 = {
  key: 1,
  class: "steps-price"
};
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "跨店满减", -1));
const _hoisted_53 = {
  key: 2,
  class: "steps-price"
};
const _hoisted_54 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "平台优惠", -1));
const _hoisted_55 = {
  key: 3,
  class: "steps-price2"
};
const _hoisted_56 = {
  class: "price2"
};
const _hoisted_57 = {
  key: 2,
  class: "openbox-result"
};
const _hoisted_58 = {
  class: "openbox-title"
};
const _hoisted_59 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "拆盒结果", -1));
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "iconfont svg-icon",
  "aria-hidden": "true"
}, [/*#__PURE__*/_createElementVNode("use", {
  "xlink:href": "#icon-nestmoreweibo"
})], -1));
const _hoisted_61 = {
  key: 0,
  class: "unpacking_type"
};
const _hoisted_62 = {
  class: "img"
};
const _hoisted_63 = ["src"];
const _hoisted_64 = {
  class: "level"
};
const _hoisted_65 = {
  class: "name"
};
const _hoisted_66 = {
  key: 4,
  class: "total"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.orderInfo.shop ? (_openBlock(), _createElementBlock("div", _hoisted_2, [!$data.env.isWeibo() ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => $options.goShop(), ["stop"]))
  }, [_hoisted_3, _createElementVNode("span", null, _toDisplayString($props.orderInfo.shop.name), 1), $props.orderInfo.shop.official != '0' ? (_openBlock(), _createElementBlock("img", _hoisted_4)) : _createCommentVNode("", true), _hoisted_5])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $props.orderInfo.shop ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.orderInfo.shop.skus, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "boom-box",
      key: index,
      onClick: _withModifiers($event => $options.goGoods(item.product_id), ["stop"])
    }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
      class: _normalizeClass(['good_card', $props.orderInfo.presale_type == 2 ? 'type2' : ''])
    }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
      src: this.$imgUrlFilter(item.product_img, this.imgWidth),
      alt: ""
    }, null, 8, _hoisted_10)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("strong", null, [$props.orderInfo.presale_type != 0 ? (_openBlock(), _createElementBlock("span", _hoisted_13)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(item.product_name), 1)]), _createElementVNode("p", null, _toDisplayString(item.sku_specs), 1), _createElementVNode("em", _hoisted_14, _toDisplayString(item.deliver_forecast_time), 1), $props.orderInfo.presale_type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("p", _hoisted_16, "¥" + _toDisplayString(item.sku_price), 1), _createElementVNode("p", _hoisted_17, "× " + _toDisplayString(item.num), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_18, [_hoisted_19, _createElementVNode("p", _hoisted_20, "¥" + _toDisplayString(item.total_amount), 1), _createElementVNode("p", _hoisted_21, "¥" + _toDisplayString(item.sku_price), 1), _createElementVNode("p", _hoisted_22, "× " + _toDisplayString(item.num), 1)]))])])], 2), item.sku_btns && item.sku_btns.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("div", {
      class: "refund_btn-btn",
      onClick: _withModifiers($event => $options.op(item.sku_btns[0].type, item.sku_order_id, item.refund_id), ["stop"])
    }, _toDisplayString(item.sku_btns[0].title), 9, _hoisted_24)])) : _createCommentVNode("", true), item.gifts && item.gifts.length ? (_openBlock(true), _createElementBlock(_Fragment, {
      key: 1
    }, _renderList(item.gifts, (item, ix) => {
      return _openBlock(), _createElementBlock("div", {
        class: "good_card gift",
        key: ix,
        style: {
          "margin-bottom": "0"
        }
      }, [_createElementVNode("div", _hoisted_25, [_createElementVNode("img", {
        src: this.$imgUrlFilter(item.product_img, this.imgWidth),
        alt: ""
      }, null, 8, _hoisted_26)]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("strong", null, [_hoisted_29, _createTextVNode(" " + _toDisplayString(item.product_name), 1)]), _createElementVNode("p", null, _toDisplayString(item.sku_specs), 1), _createElementVNode("em", _hoisted_30, _toDisplayString(item.deliver_forecast_time), 1), _createElementVNode("div", _hoisted_31, [_createElementVNode("p", _hoisted_32, "¥" + _toDisplayString(item.sku_price), 1), _createElementVNode("p", _hoisted_33, "×" + _toDisplayString(item.num), 1)])])])]);
    }), 128)) : _createCommentVNode("", true), $props.orderInfo.presale_type == 2 && $props.orderInfo.presale_pay_type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_34)) : _createCommentVNode("", true), $props.orderInfo.presale_type == 2 && $props.orderInfo.presale_pay_type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_38)) : _createCommentVNode("", true)]), item.steps && item.steps.length ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createElementVNode("div", {
      class: _normalizeClass(['top', {
        red: item.steps[0].light
      }])
    }, null, 2), _createElementVNode("div", {
      class: _normalizeClass(['line', {
        line1: item.steps[0].light && !item.steps[1].light,
        line2: !item.steps[0].light && item.steps[1].light
      }])
    }, _hoisted_45, 2), _createElementVNode("div", {
      class: _normalizeClass(['bottom', {
        red: item.steps[1].light
      }])
    }, null, 2)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.steps, (items, ix) => {
      return _openBlock(), _createElementBlock("div", {
        class: "steps-li",
        key: ix
      }, [_createElementVNode("div", {
        class: _normalizeClass(['steps-p', {
          red: item.light
        }])
      }, [_createElementVNode("span", _hoisted_46, _toDisplayString(items.step_title), 1), _createTextVNode(" " + _toDisplayString(items.status_name) + " ", 1), items.time_describe ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(items.time_describe), 1)) : _createCommentVNode("", true), ix == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_48, " ¥" + _toDisplayString(items.sku_amount), 1)) : _createCommentVNode("", true)], 2), items.seller_coupon_amount != '0.00' ? (_openBlock(), _createElementBlock("div", _hoisted_49, [_hoisted_50, _createElementVNode("span", null, "-¥" + _toDisplayString(items.seller_coupon_amount), 1)])) : _createCommentVNode("", true), items.max_reduction_coupon_amount != '0.00' ? (_openBlock(), _createElementBlock("div", _hoisted_51, [_hoisted_52, _createElementVNode("span", null, "-¥" + _toDisplayString(items.max_reduction_coupon_amount), 1)])) : _createCommentVNode("", true), items.platform_coupon_amount != '0.00' ? (_openBlock(), _createElementBlock("div", _hoisted_53, [_hoisted_54, _createElementVNode("span", null, "-¥" + _toDisplayString(items.platform_coupon_amount), 1)])) : _createCommentVNode("", true), ix == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_55, [_createElementVNode("span", null, _toDisplayString(items.step_pay_status_name), 1), _createElementVNode("span", _hoisted_56, "¥" + _toDisplayString(items.total_amount), 1)])) : _createCommentVNode("", true)]);
    }), 128))])) : _createCommentVNode("", true)], 8, _hoisted_7);
  }), 128))])) : _createCommentVNode("", true), $props.orderInfo && $props.orderInfo.card_info ? (_openBlock(), _createElementBlock("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_hoisted_59, _createElementVNode("div", {
    class: "num",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.openboxmore && $options.openboxmore(...args))
  }, [_createTextVNode(" 查看全部 (" + _toDisplayString($props.orderInfo.card_info.card_total) + ") ", 1), _hoisted_60])]), _createElementVNode("div", {
    class: "openbox-ul",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.openboxmore && $options.openboxmore(...args))
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.orderInfo.card_info.card_list, (e, ix) => {
    return _openBlock(), _createElementBlock(_Fragment, null, [ix < 3 ? (_openBlock(), _createElementBlock("div", {
      class: "openbox-li",
      key: ix
    }, [e.back_image_url ? (_openBlock(), _createElementBlock("div", _hoisted_61, "双面卡")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_62, [_createElementVNode("img", {
      src: e.card_icon
    }, null, 8, _hoisted_63), _createElementVNode("div", _hoisted_64, _toDisplayString(e.level_name), 1)]), _createElementVNode("div", _hoisted_65, _toDisplayString(e.card_name), 1)])) : _createCommentVNode("", true)], 64);
  }), 256))])])) : _createCommentVNode("", true), $props.orderInfo.amount_info && $props.orderInfo.amount_info.amount_line && $props.orderInfo.amount_info.amount_line.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 3
  }, _renderList($props.orderInfo.amount_info.amount_line, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "freight",
      key: index
    }, [_createElementVNode("span", null, _toDisplayString(item.title), 1), _createElementVNode("span", null, _toDisplayString(item.value), 1)]);
  }), 128)) : _createCommentVNode("", true), $props.orderInfo.presale_type != 2 && $props.orderInfo.amount_info ? (_openBlock(), _createElementBlock("div", _hoisted_66, [_createTextVNode(_toDisplayString($props.orderInfo.amount_info.total_amount_title) + " ", 1), _createElementVNode("span", null, _toDisplayString($props.orderInfo.amount_info.total_amount_value), 1)])) : _createCommentVNode("", true)]);
}